import { Component, input, output } from '@angular/core';
import { DeviceSyncStatus } from '@era/locations-sdk';

@Component({
  selector: 'era-device-mdm-sync-retry-ui',
  templateUrl: './device-mdm-sync-retry.component.html',
})
export class DeviceMdmSyncRetryComponent {
  public readonly deviceSyncStatus = input.required<DeviceSyncStatus>();
  public readonly retry = output<DeviceSyncStatus>();

  public onRetry() {
    this.retry.emit(this.deviceSyncStatus());
  }
}
